module.exports = __webpack_public_path__ + "UX36.png?88474879f434fb566062635759861ed4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/UX36.png
// module id = 86
// module chunks = 0